import { useState } from 'react'
import Header from '../components/Header';
import { motion } from 'framer-motion';
import ImgOne from "../assets/vaness_about_435.webp";
import ImgTwo from "../assets/vaness_about_sec_435.webp";
import "../sass/pages/_about.scss";

export default function About() {

  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);

  const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
  const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

  return (
    <>
      <Header />
      <main className='about'>
        <motion.section 
          className='first-about'
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: .3 }}
          viewport={{ once: true }}
          >
          <motion.div 
            className="card-img"
            initial={false}
              animate={
              isLoaded && isInView
                  ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                  : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
              }
              transition={{ duration: 1, delay: .3 }}
              viewport={{ once: true }}
              onViewportEnter={() => setIsInView(true)}
            >
              <img src={ImgOne} alt={"un fond rouge et gris avec un triangle blanc"} onLoad={() => setIsLoaded(true)}/>
          </motion.div>
          <div className="card-txt">
              <p>Mon nom est MOIROD Vanessa, j'ai actuellement 51 ans et suis la maman d'une magnifique fille.</p>
              <p>
                Pendant de nombreuses années, j'ai maintenu un schéma professionnel classique, et il y a environ dix ans, 
                après le décès d'un proche, je me suis remise en question et surtout je me suis lancée dans la quête de sens. 
              </p>
              <p>
                Au fil de mes lectures et de mes apprentissages, j'ai pris conscience de l'importance de l'hypnose.
              </p>
              <p>
                Mon objectif était de pratiquer une hypnose qui respecte l'individualisme de chacun. 
                De plus, en mettant l'accent sur le libre arbitre, c'est donc tout naturellement que j'ai suivi une formation à 
                l'Institut International d'Hypnose Spirituelle.
              </p>
              <p>
                J'ai souhaité intégrer dans ma pratique un outil exceptionnel qui est le GEST-EMDR; c'est pourquoi 
                j'ai suivi une formation chez Neopraxis pour des thérapies brèves.
              </p>
          </div>
        </motion.section>
        <motion.section 
          className='second-about'
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: .5 }}
          viewport={{ once: true }}
          >
          <motion.div 
            className="card-img"
            initial={false}
            animate={
            isLoaded && isInView
                ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
            }
            transition={{ duration: 1, delay: 1 }}
            viewport={{ once: true }}
            onViewportEnter={() => setIsInView(true)}
            >
              <img src={ImgTwo} alt={"un fond noir et rouge avec une bouteille"} onLoad={() => setIsLoaded(true)}/>
          </motion.div>
          <div className="card-txt">
            <p>Dans un cadre bienveillant et sécurisé, sans aucune forme de jugement, nous pouvons traiter divers sujets.</p>
            <p>Que cela soit :</p>
            <ul>
              <li>Pour vous libérer de l'addiction au tabac ou autres</li>
              <li>Afin de surmonter des obstacles</li>
              <li>Comprendre et surmonter des angoisses</li>
              <li>Renouer avec la confiance en soi</li>
              <li>Trouver la force de surmonter une phobie</li>
              <li>Ou tout autre objectif qui vous permettra de vous épanouir complètement</li>
            </ul>
            <p>Au cours de la première séance, nous accorderons une attention particulière à définir le défi à relever et la stratégie la plus adaptée.</p>
            <p>La durée de la séance varie entre 1h15 et 1h30.</p>
          </div>
        </motion.section>
      </main>
    </>
  )
}
